import React from "react";
var __jsx = React.createElement;
import dynamic from 'next/dynamic';
import { trackWebVital } from '@webtv/analytics/performance';
import { BaseApp } from '@webtv/base-app';
import { PELOTON_PLATFORM } from '@webtv/env';
import { init as initErrorReporting } from '@webtv/error-reporting-v2';
import { isFeatureEnabled, Feature } from '@webtv/feature-toggles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
initErrorReporting(); // PLATFORM SPECIFIC INIT

var SamsungHooks = dynamic(function () {
  return import('../platform-injectables/samsung');
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('../platform-injectables/samsung')];
    }
  }
});
export function reportWebVitals(metric) {
  if (isFeatureEnabled(Feature.ReportPerformanceMetrics)) {
    trackWebVital(metric);
  }
}

var App = function App(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [PELOTON_PLATFORM === 'samsung' && /*#__PURE__*/_jsx(SamsungHooks, {}), /*#__PURE__*/_jsx(BaseApp, {
      Component: Component,
      pageProps: pageProps
    })]
  });
};

export default App;